// extracted by mini-css-extract-plugin
export var container = "_6v-0";
export var error = "_6v-9";
export var label = "_6v-5";
export var light = "_6v-6";
export var md = "_6v-3";
export var sm = "_6v-2";
export var thin = "_6v-8";
export var thinBold = "_6v-7";
export var vertical = "_6v-4";
export var xs = "_6v-1";